import React from 'react';
import { FormattedTime } from 'react-intl';

export interface INullableFormattedTimeProps {
    value?: Date | string | null;
}

export class NullableFormattedTime extends React.Component<INullableFormattedTimeProps, Record<string, unknown>> {
    public override render() {
        if (!this.props.value) {
            return null;
        }
        return <FormattedTime value={this.props.value} />;
    }
}
